import Service from "../../../Services/index";
const factoryEmployeeExport = {
    namespaced : true,
    state : {
        form : {
            employee : '',
            employee_id : '',
            hr_factory_id : '',
            factory : '',
            quantity : '',
            date : '',
            user_id : '',
        },
    },
    mutations : {
        GET_FORM:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA :(state)=>{
            state.form  = {
                employee_id : '',
                hr_factory_id : '',
                quantity : '',
                date : '',
                user_id : '',
            };
        }
    },
    actions : {
        getFactoryEmployeeExport({commit}, {page,data}){
            return Service.factoryEmployeeExport.getFactoryEmployeeExport(page,data);
        },
        showFactoryEmployeeExport({commit},id){
            return Service.factoryEmployeeExport.showFactoryEmployeeExport(id);
        },
        saveFactoryEmployeeExport({commit},{id,data}){
            if(id){
                return Service.factoryEmployeeExport.updateFactoryEmployeeExport(id,data);
            }else{
                return Service.factoryEmployeeExport.createFactoryEmployeeExport(data);
            }
        },
        deleteFactoryEmployeeExport({commit},id){
            return Service.factoryEmployeeExport.deleteFactoryEmployeeExport(id);
        },
        setFormFactoryEmployeeExport({commit},res){
            commit('GET_FORM',res);
        },
        clearFormDataFactoryEmployeeExport({commit}){
            commit('CLEAR_FORM_DATA');
        }
    },
}
export default factoryEmployeeExport
